import React from 'react';

export interface ThemeContextProps {
  theme: 'dark' | 'light';
  toggleTheme: () => void;
}

export const ThemeContext = React.createContext<ThemeContextProps>({
  theme: 'dark',
  toggleTheme: () => {},
});
